/* eslint-disable */
import { Box, Button, Grid, Pagination, Typography, } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../assets/hooks";
import {
  Email,
  Phone,
  Recommendations,
  Stage,
  StudentName,
} from "./applicationData";
import { allstudentDetails, newstudentDetails } from "../../services";
import { initStudentProfile } from "../../store/slices/studentsInfo";
import ReusableTable1 from "../../components/table";
import { initApplications } from "../../store/slices/applicationSlice";
import Filters from "./filters";
import { filterOptions } from "../../assets/enums";
import { Event, FilterSelected, ListItem } from "../../types/types";
import { secondaryButton } from "../../components/styles/customStyles";
import { useNavigate } from "react-router-dom";
import { setPopup } from "../../store/slices/popupSlice";

const Counsellor = () => {
  const students = useAppSelector((state) => state.studentInfo);
  const applications = useAppSelector((state) => state.applications);
  const navigate = useNavigate()
  const role = localStorage.getItem("role");
  const dispatch = useAppDispatch();
  const [activeTab, setActiveTab] = useState<
    "students" | "leads" | "applications"|"newStudents"
  >("students");
  const [filterData,setFilterData] = useState<FilterSelected[]>([{ type: "processCoordinator",data:[]}])
  const [leadsData,setLeadsData] = useState([])
  const [newStudentsData,setnewStudentsData] = useState([])
  const [currentPage,setCurrentPage] =useState(1)
  const [totalItems,setTotalItems] =useState(0)
  const [totalPages,setTotalPages] =useState(0)
  const itemsPerPage = 20;
  const startItem = totalItems > 0  ? (currentPage - 1) * itemsPerPage + 1 :0;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);
  const studentDetails = async () => {
    const response = await allstudentDetails("students", { filterData: [],
      page: currentPage,
     });
    // console.log(response);
    if (response) {
      setTotalItems(response.data.totalItems)
      setTotalPages(response.data.totalPages)
      dispatch(
        initStudentProfile({
          requestStatus: "initiated",
          responseStatus: "recieved",
          haveAnIssue: false,
          issue: "",
          data: response.data.list,
        })
      );
    }
  };

  const applicationDetails = async () => {
    let response;

    if (role === "counsellor") {
      response = await allstudentDetails("applications", {
        filterData: [],
      page: currentPage,

      });
    } else {
      response = await allstudentDetails("applications", {
        filterData: filterData,
      page: currentPage,

      });
    }
  
    if (response.success) {
      setTotalItems(response.data.totalItems)
      setTotalPages(response.data.totalPages)
      dispatch(
        initApplications({
          requestStatus: "initiated",
          responseStatus: "recieved",
          haveAnIssue: false,
          issue: "",
          data: response.data.list,
        })
      );
    } else {
      console.error("Failed to fetch application details", response);
    }
  
    return response;
  };

  const leadDetails = async () => {
     const response = await allstudentDetails("leads", {
        filterData: [],
      page: currentPage,

      });
    if (response.success) {
     setLeadsData(response.data.list)
     setTotalItems(response.data.totalItems)
      setTotalPages(response.data.totalPages)
    } else {
      console.error("Failed to fetch application details", response);
    }
    return response;
  }; 
  const newStudents = async () => {
    const response = await newstudentDetails({
       filterData: [],
      page: currentPage,

     });
   if (response.success) {
    setTotalItems(response.data.totalItems)
      setTotalPages(response.data.totalPages)
    setnewStudentsData(response.data?.list)
   } else {
     console.error("Failed to fetch application details", response);
   }
   return response;
 }; 

  useEffect(() => {
    if (activeTab === "students") {
      if(role === "counsellor"){
        studentDetails();
      }
    } else if (activeTab === "applications") {
      applicationDetails();
    } else if (activeTab === "leads"){
      leadDetails()
    } else if ( activeTab === "newStudents"){
      newStudents()
    }
    // eslint-disable-next-line
  }, [activeTab,filterData,currentPage]);

  useEffect(() => {
    if (role === "counsellor") {
      setActiveTab("students");
    } else if (role === "processCoordinator") {
      setActiveTab("applications");
    } else {
      setActiveTab("leads");
    }
  }, [role]);

  return (
    <Box>
      <Box
        sx={{
          background: "#3B3F76",
          padding: "8px 24px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{ display: "flex", justifyContent: "space-between", gap: "15px" }}
        >
          {role === "counsellor" ? (
            <>
              <Button
                onClick={() => setActiveTab("students")}
                sx={{
                  color: "#fff",
                  borderBottom: activeTab === "students" ? "2px solid #fff" : 0,
                  borderRadius: 0,
                  textTransform: "none",
                  fontSize: "1rem",
                }}
              >
                Students
              </Button>
              <Button
                onClick={() => setActiveTab("applications")}
                sx={{
                  color: "#fff",
                  borderBottom:
                    activeTab === "applications" ? "2px solid #fff" : 0,
                  textTransform: "none",
                  borderRadius: 0,
                  fontSize: "1rem",
                }}
              >
                Applications
              </Button>
            </>
          ) : role === "processCoordinator" ? (
            <>
              <Button
                onClick={() => setActiveTab("applications")}
                sx={{
                  color: "#fff",
                  borderBottom:
                    activeTab === "applications" ? "2px solid #fff" : 0,
                  textTransform: "none",
                  borderRadius: 0,
                  fontSize: "1rem",
                }}
              >
                Applications
              </Button>
            </>
          ) : (
            <>
            <Button
              onClick={() => setActiveTab("leads")}
              sx={{
                color: "#fff",
                borderBottom: activeTab === "leads" ? "2px solid #fff" : 0,
                borderRadius: 0,
                textTransform: "none",
                fontSize: "1rem",
              }}
            >
              Leads
            </Button>
            <Button
                onClick={() => setActiveTab("newStudents")}
                sx={{
                  color: "#fff",
                  borderBottom:
                    activeTab === "newStudents" ? "2px solid #fff" : 0,
                  textTransform: "none",
                  borderRadius: 0,
                  fontSize: "1rem",
                }}
              >
                New Students
              </Button>
            </>
          )}
        </Box>
        <Box sx={{ display: "flex",gap: "15px",alignItems:"center"}}>
        {role === "counsellor" && <Button sx={[secondaryButton,{fontSize:"14px"}]} onClick={()=>navigate("/createBlog")}>Create a blog</Button> }
        {role === "counsellor" && <Button sx={[secondaryButton,{fontSize:"14px"}]} onClick={()=>navigate("/addcountry")}>Add country </Button> }
        { role === "admin" && 
          <Button sx={[secondaryButton,{fontSize:"14px"}]} 
           onClick={() =>
            dispatch(
              setPopup({
                show: true,
                data: {
                  container: {
                    name: "crTeam",
                    dimensions: {
                      width: "40%",
                    },
                  },
                  type: "custom",
                },
              }))
          }>Create a team</Button> }
        {role === "admin" && (
          <Button
            sx={[secondaryButton, { fontSize: "14px" }]}
            onClick={() =>
              dispatch(
                setPopup({
                  show: true,
                  data: {
                    container: {
                      name: "changeAdvisor",
                      dimensions: {
                        width: "450px",
                      },
                    },
                    type: "custom",
                  },
                })
              )
            }
          >
            Change advisor
          </Button>
        )}
           {role === "counsellor" && 
          <Button sx={[secondaryButton,{fontSize:"14px"}]} 
           onClick={() =>
            dispatch(
              setPopup({
                show: true,
                data: {
                  container: {
                    name: "crUser",
                    dimensions: {
                      width: "450px",
                    },
                  },
                  type: "custom",
                },
              }))
          }>Create a user</Button> }

          </Box>
      </Box>
      <Grid container sx={{ mt: 1 }}>
              <Grid item xs={8} lg={12}>
                <Typography sx={{ display: "flex", gap: "0.5rem", pl: 2 }}>
                  <span style={{ color: "#3b3f76", fontWeight: "500" }}>
                    {startItem}-{endItem}
                  </span>
                  out of
                  <span style={{ color: "#3b3f76", fontWeight: "500" }}>
                    {totalItems}
                  </span>
                  results
                </Typography>
              </Grid>
            </Grid>
      <MainComponent
        activeTab={activeTab}
        students={students}
        applications={applications}
        setFilterData={setFilterData}
        filterData={filterData}
        leadsData={leadsData}
        newStudentsData={newStudentsData}
      />
       <Box sx={{ display: "flex", justifyContent: "center", gap: "20px", my: 2 }}>
          {startItem > 0 &&  <Pagination
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: 1,
                  "& .MuiPaginationItem-root.Mui-selected": {
                    background: "#3B3F76 !important",
                    color: "#fff",
                    borderRadius:"5px",
                    height: "28px",
                    minWidth: "28px",
                  },
                }}
                count={totalPages}
                page={currentPage}
                onChange={(event, value) =>
                  setCurrentPage(value)
                }
                showFirstButton
                showLastButton
              /> }
            </Box>
    </Box>
  );
};

export default Counsellor;

interface MainComponentProps {
  activeTab: string;
  students: any;
  applications: any;
  setFilterData:any;
  filterData:any;
  leadsData:any;
  newStudentsData:any;
}
function formatDate(dateString: string, day: boolean): string {
  const options: Intl.DateTimeFormatOptions = day
    ? { year: "numeric", month: "long" }
    : { year: "numeric", month: "long", day: "numeric" };
  return new Date(dateString).toLocaleDateString(undefined, options);
}
const MainComponent: React.FC<MainComponentProps> = ({
  activeTab,
  students,
  applications,
  filterData,
  setFilterData,
  leadsData,
  newStudentsData,
}) => {
  const [columns, setColumns] = useState<any[]>([]);
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (activeTab === "students") {
      setColumns(studentcolumns);
    } else if (activeTab === "applications") {
      setColumns(applicationRows);
    }
    // eslint-disable-next-line
  }, [activeTab,filterData]);

  const mapStudentData = (students: any[]) => {
    return students.map(student => ({
      name: (
        <StudentName
          name={student.firstName + " " + student.lastName}
          displayPicSrc={student.displayPicSrc}
          id={student._id}
          type="student"
        />
      ),
      stage: <Stage stage={student.stage} id={student._id}/>,
      contact: (
        <>
          <Email email={student.email} verification={student.verification} />
          <Phone phone={student.phone} verification={student.verification} />
        </>
      ),
      recommendations: <Recommendations data={student?.recommendations?.data} />,
      country: (
        <ul style={{ padding: 0, paddingLeft: "20px" }}>
          {student.preference.country.length > 0
            ? student.preference.country.map((item: string, i: number) => (
                <li key={i}>{item}</li>
              ))
            : "N/A"}
        </ul>
      ),
      intake: student.preference?.intake ? formatDate(student.preference?.intake, true) : "N/A",
      degree: student?.preference?.degree || "N/A",
      budget:
        student.preference?.budget?.upper && student?.preference?.budget?.lower
          ? `${student.preference?.currency} ${student.preference?.budget?.upper.toLocaleString(
              "en-US"
            )} - ${student.preference?.budget?.lower.toLocaleString("en-US")}`
          : "N/A",
      language: student.preference.language || "N/A",
    }));
  };
  
  const mapApplicationData = (applications: any) => {
    console.log("applications",applications.data.map((item:any)=>item.course?.university?.name));
    return applications.data.map((application:any) => ({
      name: (
        <StudentName
          name={application.user !== null ? application.user?.firstName + " " + application.user?.lastName :"Deleted User"}
          displayPicSrc={application?.user?.displayPicSrc}
          id={application._id}
          type="application"
        />
      ),
      ProgramName:<>
      <div style={{ color: "#FEB853", fontWeight: 600 }}>
                  {application.course?.university?.name}
                </div>
                <div style={{ fontWeight: 500 }}>{application.course?.name}</div></>,
      Deadline:formatDate(application.deadline, true),
      AppliedDate:formatDate(application.createdAt, true),
      Intake: application.intake ? formatDate(application.intake, true) : "N/A",
      Status:application.status,
      Stage: application.stage,
    }));
  };

  const mapLeadsData = (leadsData: any[]) => {
    return leadsData.map(student => ({
      name:student?.name ,
      email: student?.email,
      phoneNumber:student?.phone && (student?.phone?.countryCode +" "+ student?.phone?.number) ,
      queryDescription: student?.queryDescription,
      leadRating: student?.leadRating || "N/A",
    }));
  };

  const studentcolumns = [
    { key: "name", name: "Name", minWidth: 150 },
    { key: "stage", name: "Stage", minWidth: 120 },
    { key: "contact", name: "Email / Phone", minWidth: 250 },
    { key: "recommendations", name: "Recommendations", minWidth: 150 },
    { key: "country", name: "Country", minWidth: 100 },
    { key: "intake", name: "Intake", minWidth: 100 },
    { key: "degree", name: "Degree", minWidth: 100 },
    { key: "budget", name: "Budget", minWidth: 150 },
    { key: "language", name: "Language", minWidth: 100 },
  ];
  const newstudentcolumns = [
    { key: "name", name: "Name", minWidth: 150 },
    // { key: "stage", name: "Stage", minWidth: 120 },
    { key: "contact", name: "Email / Phone", minWidth: 250 },
    // { key: "recommendations", name: "Recommendations", minWidth: 150 },
    { key: "country", name: "Country", minWidth: 100 },
    // { key: "intake", name: "Intake", minWidth: 100 },
    // { key: "degree", name: "Degree", minWidth: 100 },
    // { key: "budget", name: "Budget", minWidth: 150 },
    { key: "language", name: "Language", minWidth: 100 },
  ];
  const applicationRows = [
    { key: "name", name: "Name", minWidth: 150 },
    { key: "ProgramName", name: "Program Name", minWidth: 150 },
    { key: "Deadline", name: "Deadline", minWidth: 200 },
    { key: "AppliedDate", name: "Applied Date", minWidth: 200 },
    { key: "Intake", name: "Intake", minWidth: 100 },
    { key: "Status", name: "Status", minWidth: 100 },
    { key: "Stage", name: "Stage", minWidth: 100 },
  ];
  const leadsRows = [
    { key: "name", name: "Name", minWidth: 150 },
    { key: "email", name: "Email", minWidth: 150 },
    { key: "phoneNumber", name: "Phone Number", minWidth: 200 },
    { key: "queryDescription", name: "Description", minWidth: 200 },
    { key: "leadRating", name: "Lead Rating", minWidth: 200 },
  ];
  
  const eventHandler = (event: Event) => {
    switch (event.name) {
        case "filterUpdated":
          setFilterData([...filterData,event.data])
          // navigate(`/explore?activeTab=${JSON.stringify(activeTab.current)}&FilterData=${(JSON.stringify(event.data))}&page=${JSON.stringify(1)}&search=${JSON.stringify("")}`)
        break

       
    }
  };

  const FilterData= useRef<FilterSelected[]>([]);

  return (
    <div className="main-content" style={{ marginTop: "1rem" }}>
      {/* <Filters
            options={filterOptions.coordinator}
            appliedFilters={FilterData.current}
            setAppliedFilter={(data: FilterSelected[]) => {
              eventHandler({ name: "filterUpdated", data: data });
            }}
          /> */}
            
      {activeTab === "students" ? (
       <ReusableTable1 columns={columns} data={mapStudentData(students.data)} />
      ) : activeTab === "applications" ? (
        <ReusableTable1 columns={columns} data={mapApplicationData(applications)} />
      ):activeTab === "leads" ? (
        <ReusableTable1 columns={leadsRows} data={mapLeadsData(leadsData)} />
      ):activeTab === "newStudents" ? (
        <ReusableTable1 columns={newstudentcolumns} data={mapStudentData(newStudentsData)} />
      ):""}

    </div>
  );
};
